import { render, staticRenderFns } from "./resignationInheritanceDetail.vue?vue&type=template&id=8ed45238&scoped=true"
import script from "./resignationInheritanceDetail.vue?vue&type=script&lang=js"
export * from "./resignationInheritanceDetail.vue?vue&type=script&lang=js"
import style0 from "./resignationInheritanceDetail.vue?vue&type=style&index=0&id=8ed45238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed45238",
  null
  
)

export default component.exports